import {
    /** FETCH APPLICATION  */
    FETCH_SETSURVEY_FULFILLED,
    FETCH_SETSURVEY_REJECTED,
    FETCH_SETSURVEY_PENDING,
    RESET
} from "../../actions/application/setSurvey";
const initialState = {
    done: false,
    error: {},
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SETSURVEY_PENDING:
            return {
                done: false,
                error: {},
                spinner: true
            };
        case FETCH_SETSURVEY_FULFILLED:
            return {
                ...state,
                setSurvey: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_SETSURVEY_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: {},
            };
        default:
            return state;
    }
};